import React from 'react';

import { MtxButton } from '@meilleurtaux/mtp-uikit-react';
import { useTranslation } from 'react-i18next';

import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

interface ContentModalValidateArbitrageProps {
  onReviewProposal: () => void;
  onContinueFromValidateModal: () => void;
}
export const ContentModalValidateArbitrage: React.FC<ContentModalValidateArbitrageProps> = ({
  onReviewProposal,
  onContinueFromValidateModal,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.content}>
      <div className={styles.modalValidateContainer}>
        <h2 className={styles.title}>{t('summaryArbitrage.validateModal.title')}</h2>
        <div>
          <p className={styles.description}>{t('summaryArbitrage.validateModal.question')}</p>
        </div>
      </div>
      <div className={styles.buttonAction}>
        <MtxButton
          variant="tertiary"
          size="large"
          fullWidth
          onClick={() => {
            void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
              event_id: 'clic',
              event_categorie: 'clic',
              event_metier: 'placement',
              event_nom: 'revoir_la_proposition',
              event_detail_1: 'popin',
              event_detail_2: 'risque_superieur_a_votre_profil_investisseur',
            });
            onReviewProposal();
          }}
        >
          {t('summaryArbitrage.validateModal.reviewProposalButton')}
        </MtxButton>
        <MtxButton
          variant="primary"
          size="large"
          fullWidth
          onClick={() => {
            void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
              event_id: 'clic',
              event_categorie: 'clic',
              event_metier: 'placement',
              event_nom: 'continuer',
              event_detail_1: 'popin',
              event_detail_2: 'risque_superieur_a_votre_profil_investisseur',
            });
            onContinueFromValidateModal();
          }}
        >
          {t('summaryArbitrage.validateModal.continueButton')}
        </MtxButton>
      </div>
    </div>
  );
};
